/**
 * Bump when shipping a new Android/iOS build so notification permission can be
 * re-requested once after install/update (see notificationService).
 * Keep aligned with package.json "version" when you release.
 */
export const APP_RELEASE_VERSION = '1.0.31';
